<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__removeFormat">mdi-format-clear</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'removeFormat',
  methods: {
    onClick () {
      this.$emit('click', 'removeFormat')
    }
  }
}
</script>

<style scoped>
#RTE__command__removeFormat {
  font-size: 20px;
}
</style>
